<template>
  <v-layout fill-height column>
    <div class="question" v-html="question"></div>

    <div class="answer flex-grow-0">
      <!-- 3으로변경 -->
      <v-row class="immersion-time-result">
        <v-col cols="2" sm="4"
               class="label">횟수</v-col>
        <v-col cols="10" sm="7"
               class="text">
          <span class="cnt">{{data[0]}}</span>
          <span class="unit">회</span>
        </v-col>
        <v-col cols="2" sm="4"
               class="label align-start">시점</v-col>
        <v-col cols="10" sm="7" md="5" lg="4"
               class="text">
          <v-row class="immersion-time-list">
            <v-col v-for="n in data[1].length" :key="n"
                   cols="4" sm="3"
                   class="immersion-time-list-item"
                   v-show="data[1][n-1]"
            >{{ (data[1][n-1]) ? data[1][n-1] : '비었으' }}</v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <FooterBtnsNext  @before="$emit('before')" @next="$emit('next')" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props:{
    current:Number,
    total:Number,
  },
  data: ()=> ({
    question:'몰입 결과 확인',
    value:'',
    data:[5,['00:30','00:30','00:30','00:30']]
  }),
  components:{
    FooterBtnsNext
  },
  computed: {
  },
  methods:{
   inputChanged(input){
     this.value = input;
   },
  }
}
</script>
